import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const GridNoOverflow = styled(({ ...props }) => <Grid item {...props} />)`
    display: flex;
    overflow: hidden;
`;
